import { ITEMS_QUANTITY_CHANGED } from '../actionTypes/CartActionTypes';

export default function ItemsQuantityChangedReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case ITEMS_QUANTITY_CHANGED:
            return action.payload || state;
        default:
            return state;
    }
}
